export enum ContentMediaTypeEnum {
  NONE = "NONE",
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  GIF = "GIF",
  AUDIO = "AUDIO",
}
